import styled from 'styled-components';

export const HeaderBox = styled.div`
    color: white;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	// align-items: center;

    .headerInfoBox {
        // background-color: rgba(0,0,0,0.5);
        width: 1060px;
        max-width: 95%;
        text-align: center;
        // margin-top: ${window.screen.width <= 1000 ? '48%' : '15%'};
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-top: ${window.screen.width <= 1000 ? '10%' : '5%'};

        .input-button {
            // font-weight: bold;
            // font-size: ${window.screen.width <= 1000 ? '1.1rem' : '2rem'};
            margin: 0.5em 0 0 0;
            // max-width: ${window.screen.width <= 1000 ? '100%' : '70%'};;
            height: auto;
            align-self: center;
        }

        h1 {
            text-shadow: rgba(0,0,0,0.7) 0px 0px 5px;
            background-color: rgba(0,0,0,0.02);
            // text-shadow: rgba(128,103,50, 0.5) 0px 0px 5px;
            font-size: ${window.screen.width <= 1000 ? '1.4rem' : '3.7rem'};
            margin: 0;
        }

        .home-header-button {
            // width: 500px;
            max-width: 100%;
        }
    }
`;
